var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#1B1C22"}},[_c('div',{staticClass:"no-page flex-center"},[_vm._v(" Sorry!The Page you’re looking for cannot be found. "),_c('router-link',{staticClass:"inline-block",attrs:{"to":"/"}},[_vm._v("Go to Homepage")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }